<template>
  <div class="header-btn-icon pointer" @click="changeMicStatus">
    <el-tooltip
      :content="$t('aheader.麦克风已关闭')"
      placement="bottom-start"
      v-if="audioStatus == 'inactive'"
    >
    <img :src="require('@/svg/mic_main.svg')" v-if="avctl == 0 && authAudio == 0" />
    <img :src="require('@/svg/mic_main.svg')" v-else-if="liveConfig?.liveondemandVoiceStatus === 0 && (mediaStatus == 2 || mediaStatus == 3)" />
    <img :src="require('@/svg/mic_close.svg')" v-else width="13px" />
    </el-tooltip>

    <el-tooltip
      :content="$t('aheader.麦克风已开启')"
      placement="bottom-start"
      v-if="audioStatus == 'active'"
    >
    <img :src="require('@/svg/mic_main.svg')" v-if="liveConfig?.liveondemandVoiceStatus === 0 && (mediaStatus == 2 || mediaStatus == 3)" />
      <img :src="require(`@/svg/mic-sprite${positionX}.png`)" width="13px" v-else />
    </el-tooltip>
    <el-tooltip
      :content="$t('aheader.麦克风已关闭')"
      placement="bottom-start"
      v-if="audioStatus == 'disabled' || !audioStatus"
    >
    <img :src="require('@/svg/mic_close2.svg')" />
    </el-tooltip>
  </div>
</template>

<script>
// import sprite from '@/svg/mic-sprite.svg';
import micSprite from '@/svg/single-mic-sprite.svg';
import { mapGetters } from 'vuex';
export default {
  name: 'audioControl',
  data() {
    return {
      spriteUrl: micSprite,
      positionX: 0,
      intervals: [
        { min: 0, value: 0 },
        { min: 1, value: -20 },
        { min: 26, value: -38 },
        { min: 51, value: -56 },
        { min: 76, value: -74 }
      ]
    };
  },
  props: {
    volume: {
      type: Number,
      required: false
    },
    big: {
      type: Boolean,
      required: false
    }
  },
  created() {
    this.init(this.volume);
  },
  computed: {
    ...mapGetters(['liveConfig', 'userInfo','mediaStatus', 'inputInstant']),
    authAudio() {
      return (
        this.$store.getters.meetStatusInfo &&
        this.$store.getters.meetStatusInfo.groupInfo &&
        this.$store.getters.meetStatusInfo.groupInfo.audio
      );
    },
    avctl() {
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.avctl;
    },
    audioStatus() {
      return this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.mediaStatus
        ? this.$store.getters.selfParticipant.mediaStatus.audio
        : "disabled";
    },
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
  },
  watch: {
    volume: {
      immediate: true,
      handler(val) {
        this.init(val);
      }
    },
    inputInstant (val){
      this.init(val);
    }
  },
  methods: {
    changeMicStatus() {
      if (
        this.liveConfig?.liveondemandVoiceStatus === 0 &&
        (this.mediaStatus == 2 || this.mediaStatus == 3)
      ) {
        this.$message.error(this.$t('lianmai.插播静音已开启，您暂时不能开关麦克风'));
        return;
      }

      console.log(this.authAudio + ',' + this.avctl + ',' + this.audioStatus, '声音变量');

      // 2.0.10 允许嘉宾与主播关闭音视频设备
      if (this.audioStatus == 'inactive' && this.avctl == 0 && this.authAudio == 0) {
        this.$message.error(this.$t('aheader.音频主控模式已开启，禁止打开麦克风'));
        return;
      }


      let status = 'inactive';
      if (this.audioStatus == 'active') {
        status = 'inactive';
      } else {
        status = 'active';
      }
      this.rtcClient.RTCRoom.muteParticipant(this.userInfo.uid, this.userInfo.cid, status).then(
        () => {
          console.log('开启关闭声音', status);
          this.$store.commit('SET_SELFAUDIOSTATUS', status);
        }
      );
    },
    init(volume) {
      this.positionX = this.volumeShow(Number(volume));
    },
    volumeShow(volume) {
      if (volume == 0 || isNaN(volume)) {
        volume = 1
      }
      const level = Math.ceil(volume / 20);
      return level - 1
    }
  }
};
</script>

<style scoped lang="scss">
.volume-bar {
  height: 1.25rem;
  width: 1.25rem;
  background-repeat: no-repeat;
  background-size: 6.25rem auto;
  background-position: -0px -0px;
}

.big-volume-bar {
  height: 1.25rem;
  width: 0.9rem;
  background-size: 4.3rem auto;
  position: absolute;
  left: 1px;
  bottom: 1px;
}
.volume-abs {
  /* position: absolute;
  left: -3px;
  bottom: 0; */
}
.header-btn-icon {
  width: 32px;
  height: 32px;
  background: rgba(221, 221, 221, 0.1);
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}
[data-theme='Orange'] .header-btn-icon {
  background: rgba(221, 221, 221, 0.5);
}

.micSprite {

  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: cover;

}
</style>
